<template>
  <div>
    <h1 class="pa-3 text-xs-center">USER MERCHANT LIST</h1>
    <div>
      <v-data-table
        :rows-per-page-items="[25, 50, 100]"
        :headers="headers"
        :items="userMerchantList"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            {{ userMerchantList.indexOf(props.item) + 1 }}
          </td>
          <td class="text-xs-center">{{ props.item.user_first_name }}</td>
          <td class="text-xs-center">{{ props.item.user_last_name }}</td>
          <td class="text-xs-center">{{ props.item.user_email }}</td>
          <td class="text-xs-center">
            {{ props.item.user_country_tel }}{{ props.item.user_tel }}
          </td>
          <td class="text-xs-center">
            <v-btn icon color="info"><v-icon>edit</v-icon></v-btn>
            <v-btn icon color="warning" @click="viewStore(props.item)"
              ><v-icon>store</v-icon></v-btn
            >
          </td>
        </template>
      </v-data-table>
    </div>
    <edit-user-form-dialog />
    <user-store-list-dialog
      :dialog="dialogStoreList"
      :storeList="storeList"
      :isLoadingStore="isLoadingStore"
      @close="
        dialogStoreList = false;
        storeList = [];
      "
      @add=""
      @delete=""
    />
  </div>
</template>

<script>
import EditUserForm from "@/components/back-office/Merchant/EditUserForm.vue";
import UserStoreList from "@/components/back-office/Merchant/UserStoreList.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogStoreList: false,
      isLoadingStore: false,
      storeList: [],
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "First name",
          sortable: false,
          align: "center",
          value: "calories",
        },
        { text: "Last name", sortable: false, align: "center", value: "fat" },
        { text: "E-mail", sortable: false, align: "center", value: "carbs" },
        { text: "Tel.", sortable: false, align: "center", value: "protein" },
        { text: "", sortable: false, value: "iron" },
      ],
      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%",
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: "1%",
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: "7%",
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: "8%",
        },
        {
          name: "Gingerbread",
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: "16%",
        },
        {
          name: "Jelly bean",
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: "0%",
        },
        {
          name: "Lollipop",
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: "2%",
        },
        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: "45%",
        },
        {
          name: "Donut",
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: "22%",
        },
        {
          name: "KitKat",
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: "6%",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userMerchantList: (state) => state.fetchUserBack.userMerchantList,
    }),
  },
  methods: {
    async viewStore(info) {
      this.dialogStoreList = true;
      this.isLoadingStore = true;
      this.storeList = await this.$store.dispatch(
        "fetchStoreBack/getAllStoreByUser",
        info.user_id
      );
      this.isLoadingStore = false;
    },
  },
  created() {
    this.$store.dispatch("fetchUserBack/getAllUserMerchant");
  },
  components: {
    "edit-user-form-dialog": EditUserForm,
    "user-store-list-dialog": UserStoreList,
  },
};
</script>
<style lang="scss" scoped>
</style>